export const getEditBandJson = (data) => {
    console.log('info----->',data)
    const EditBandForm = {
      totalpages: 1,
      pages: [
        {
          modalView: false,
          colSpan: [24, 24, 24],
          fields: [
            [
              {
                id: 1,
                label: "Band Name:",
                type: "text",
                name: "bandname",
                Placeholder: "Bandname",
                value: data["bandname"],
                validationRules: [
                  {
                    required: true,
                    message: `Please enter your Band Name`,
                  },
                ],
              },
            ],
            [
              {
                id: 2,
                label: "Salary from:",
                type: "text",
                name: "salaryfrom",
                Placeholder: "Salaryfrom",
                value: data["salaryfrom"],
                validationRules: [
                  {
                    required: true,
                    message: `Please enter the salary from`,
                  },
                ],
              },
              {
                id: 3,
                label: "Salary To:",
                type: "text",
                name: "salaryto",
                Placeholder: "Salaryto",
                value: data["salaryto"],
                validationRules: [
                  {
                    required: true,
                    message: `Please enter the salary to`,
                  },
                ],
              },
            ],
            [
              {
                id: 4,
                label: "Experience from:",
                type: "date",
                name: "experiencefrom",
                Placeholder: "Experiencefrom",
                value: data["experiencefrom"],
                validationRules: [
                  {
                    required: true,
                    message: `Please select the experience from`,
                  },
                ],
              },
              {
                id: 5,
                label: "Experience To:",
                type: "date",
                name: "experienceto",
                Placeholder: "Experienceto",
                value: data["experienceto"],
                validationRules: [
                  {
                    required: true,
                    message: `Please select the experience to`,
                  },
                ],
              },
            ],
          ],
        },
      ],
    };
  
    return {
        EditBandForm,
    };
  };